/* eslint-disable */

// Utility function
const Util = () => {};

// Helper functions to manipulate class attr
Util.hasClass = (el, className) => {
	if (el.classList) return el.classList.contains(className);
	return !!el.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
};

Util.addClass = (el, className) => {
	const classList = className.split(' ');
 	if (el.classList) el.classList.add(classList[0]);
 	else if (!Util.hasClass(el, classList[0])) el.className += ` ${classList[0]}`;
 	if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = (el, className) => {
	const classList = className.split(' ');
	if (el.classList) el.classList.remove(classList[0]);
	else if (Util.hasClass(el, classList[0])) {
		const reg = new RegExp(`(\\s|^)${classList[0]}(\\s|$)`);
		el.className = el.className.replace(reg, ' ');
	}
	if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

// Smooth Scroll
Util.scrollTo = (final, duration, cb) => {
	const start = window.scrollY || document.documentElement.scrollTop;
	let currentTime = null;

	const animateScroll = (timestamp) => {
  	if (!currentTime) currentTime = timestamp;
		let progress = timestamp - currentTime;
		if (progress > duration) progress = duration;
		const val = Math.easeInOutQuad(progress, start, final - start, duration);
		window.scrollTo(0, val);
		if (progress < duration) {
			window.requestAnimationFrame(animateScroll);
		} else {
			cb && cb();
		}
	};

	window.requestAnimationFrame(animateScroll);
};

// Calculate transition animation curves
Math.easeInOutQuad = (t, b, c, d) => {
	t /= d / 2;
	if (t < 1) return c / 2 * t * t + b;
	t--;
	return -c / 2 * (t * (t - 2) - 1) + b;
};

export default Util;
